const ControlIconToIconMap = {
    'arrow-r': {
        iconType: 'chevronRight',
        size: '20p'
    },
    'arrow-l': {
        iconType: 'chevronLeft',
        size: '20p'
    },
    'arrow-u': {
        iconType: 'caretUp',
        size: '20p'
    },
    'arrow-d': {
        iconType: 'caretDown',
        size: '20p'
    },
    check: {
        iconType: 'check',
        size: '20p'
    },
    close: {
        iconType: 'close',
        size: '20p'
    },
    'close-small': {
        iconType: 'closeSmall',
        size: '10p'
    },
    'close-large': {
        iconType: 'closeLarge',
        size: '28p'
    },
    download: {
        iconType: 'download',
        size: '20p'
    },
    error: {
        iconType: 'error',
        size: '20p',
        skin: 'error'
    },
    info: {
        iconType: 'info',
        size: '20p'
    },
    menu: {
        iconType: 'menu',
        size: '28p'
    },
    minus: {
        iconType: 'minus',
        size: '20p'
    },
    'password-show': {
        iconType: 'passwordShow',
        size: '20p'
    },
    'password-hide': {
        iconType: 'passwordHide',
        size: '20p'
    },
    plus: {
        iconType: 'plus',
        size: '20p'
    },
    redo: {
        iconType: 'redo',
        size: '28p'
    },
    save: {
        iconType: 'save',
        size: '28p'
    },
    search: {
        iconType: 'search',
        size: '20p'
    },
    'search-large': {
        iconType: 'searchLarge',
        size: '28p'
    },
    undo: {
        iconType: 'undo',
        size: '28p'
    },
    'zoom-in': {
        iconType: 'zoomIn',
        size: '28p'
    },
    'zoom-out': {
        iconType: 'zoomOut',
        size: '28p'
    }
};

export { ControlIconToIconMap };
